import { Injectable } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatDialog, MatDialogConfig, MatDialogState } from '@angular/material/dialog';
import { CancelOrderComponent } from 'src/app/components/dialogs/cancel-order/cancel-order.component';
import { ToolsService } from '../tools/tools.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import {PanierService} from "../manage/panier/panier.service";
import {SalemethodService} from "../api/salemethod/salemethod.service";


@Injectable({
  providedIn: 'root'
})
export class borneOrderService {

  timer: any;
  dialogContinueOrder: any;
  // dialog borne
  private borneDialo: BehaviorSubject<any> = new BehaviorSubject(null);
  dialogBorne: any;
  urlsparams: any
  currPos: any
  constructor(
    public media: MediaObserver,
    private dialog: MatDialog,
    private tools: ToolsService,
    private route: ActivatedRoute,
    private router: Router

  ) {


    this.getborneDialo().subscribe((dial) => {
      this.dialogBorne = dial;
    })

  }
  // Return the Observable of the current borneDialo
  getborneDialo(): Observable<any> {
    return this.borneDialo.asObservable();
  }

  //set borneDialo
  setborneDialo(value: any): void {
    this.borneDialo.next(value);
  }


  //reset le timeout
  removeContinueOrderTimeout() {

    if (this.timer) {
      //cancel the previous timer.
      clearTimeout(this.timer);
      this.timer = null;
    }


  }





  //set le timeout et appel la function
  setContinueOrderTimeout(time?: any) {

    let sm = this.tools.getStor(SalemethodService.TAG_STORAGE) ? this.tools.getStor(SalemethodService.TAG_STORAGE) : null;

    if (sm && sm.disable_authentification && this.tools.getStor("devicePaybridge") &&
      (this.tools.checkCurrentPage("endorder") || this.tools.checkCurrentPage("product"))) {


      let timeout = 30 * 1000;


      if (!this.timer) {
        this.timer = setTimeout(() => {
          //call dialog
          this.continueOrderDialog();
        }, timeout);
      }
    }

  }


  continueOrder(prov?: any) {



    this.removeContinueOrderTimeout();
    this.setContinueOrderTimeout();

  }



  setParams(value: any) {
    this.urlsparams = value;
  }
  setcurpos(value: any) {
    this.currPos = value;
  }

  continueOrderDialog(): void {


    //basket et dialog fermé
    if (
      !this.tools.getStor(PanierService.TAG_STORAGE)
      || (this.dialogContinueOrder && this.dialogContinueOrder.getState() === MatDialogState.OPEN)
      || (this.dialogBorne && this.dialogBorne.getState() === MatDialogState.OPEN)
    ) {
      this.continueOrder();
      return;
    }

    let sm=this.tools.getStor(SalemethodService.TAG_STORAGE)?this.tools.getStor(SalemethodService.TAG_STORAGE):null;

    const myConf = new MatDialogConfig();

    myConf.disableClose = true;

    this.media.isActive("xs")
      ? (myConf.width = "100%", myConf.height = "100%", myConf.panelClass = "dialog-borne")
      : (myConf.width = "80%", myConf.height = "80%", myConf.panelClass = "dialog-borne");
    this.dialogContinueOrder = this.dialog.open(CancelOrderComponent, myConf);

    this.dialogContinueOrder.afterClosed().subscribe((result: any) => {


      if (!result) {
        //continuation
        this.continueOrder();
      }
      else {


        //Annulation
        this.removeContinueOrderTimeout();

        //redirection


        //ferme la dialogue si ouverte
        if (this.dialogBorne && this.dialogBorne.getState() === MatDialogState.OPEN) {
          this.dialogBorne.close();
        }

        if (this.tools.checkCurrentPage("endorder")) {
          setTimeout(() => {
             this.tools.goProductPage(null,sm);
          }, 0);
        }
        else if (this.tools.checkCurrentPage("product")) {


          setTimeout(() => {

              window.location.reload();


          }, 0);
        }

      }




    });



  }





}
